<template>
  <SPASnackbar class="ReportDownloadSnackbar" v-model="snackbarObj[1]"> File downloaded successfully </SPASnackbar>
  <SPASnackbar class="ReportDownloadSnackbar" v-model="snackbarObj[2]"> File downloaded successfully </SPASnackbar>
  <SPASnackbar class="ReportDownloadSnackbar" v-model="snackbarObj[3]"> File downloaded successfully </SPASnackbar>
  <SPASnackbar class="ReportDownloadSnackbar" v-model="snackbarObj[4]"> File downloaded successfully </SPASnackbar>
  <SPASnackbar class="ReportDownloadSnackbar" v-model="snackbarObj[5]"> File downloaded successfully </SPASnackbar>
</template>
<style lang="scss">
// Because of its appendToBody nature, it cannot be scoped.
.ReportDownloadSnackbar {
  cursor: pointer;
  color: $neutral-0;
}
</style>
<script>
import { storeToRefs } from 'pinia';
import SPASnackbar from '../../components/SPASnackbar.vue';
import { useReportStore } from '../../stores/report';
export default {
  name: 'ReportDownloadSnackbar',
  components: { SPASnackbar },
  setup() {
    const reportStore = useReportStore();
    const { snackbarObj } = storeToRefs(reportStore);
    return { snackbarObj };
  },
};
</script>
